import { SxProps } from "@mui/material";

const step: SxProps = {
  height: "32px",
  width: "32px",
  border: "1.5px solid #898A8D",
  borderRadius: "50%",
  display: "flex",
  justifyContent: "center",
  alignItems: "center",
  fontSize: "1rem",
  fontWeight: "400",
  position: "relative",
  background: "#fff",
};

const selectedStep: SxProps = {
  backgroundColor: "secondary.main",
  color: "common.white",
  borderColor: "secondary.main",
};

const completedStep: SxProps = {
  backgroundColor: "#00953B",
  color: "#ffffff",
  borderColor: "#00953B",
};

const stepLine: SxProps = {
  width: "calc((100% - 32px * 5) / 4)",
  height: "1.5px",
  background: "#898A8D",
};

const styles = {
  step,
  selectedStep,
  completedStep,
  stepLine,
};

export default styles;
